import { render, staticRenderFns } from "./AddGallary.vue?vue&type=template&id=6413c0c1&"
import script from "./AddGallary.vue?vue&type=script&lang=js&"
export * from "./AddGallary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports